import { loader } from 'graphql.macro'

export default function job ({ dataLoaders, queryKey }) {
  const [, id] = queryKey
  const jobSchema = loader('./job.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(jobSchema, { id })
}
